export const toArray = async (source) => {
    const array = [];
    for await (const item of source) {
        array.push(item);
    }
    return array;
};
